/**
 * @fileoverview DELETE handler for the "/:app_group_id/knowledge_source/definition/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitionIdCacheKeys } from "./constants";
import type { DeleteKnowledgeSourceDefinitionIdErrors, DeleteKnowledgeSourceDefinitionIdProps } from "./types";

export const deleteKnowledgeSourceDefinitionId = reactQueryMutationAdapter(
  knowledgeSourceDefinitionIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteKnowledgeSourceDefinitionIdErrors>()(
    (props: DeleteKnowledgeSourceDefinitionIdProps): Promise<{}> => {
      return fetch(
        `/${props.appGroupId}/knowledge_source/definition/${props.definitionId}`,
        "DELETE",
        {},
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
